import type { Organization } from "@common/types/organization";
import { Avatar, type AvatarSize } from "@design-system/Avatar/Avatar";
import { KickLogo } from "@design-system/KickLogo/KickLogo";

export interface OrganizationAvatarProps {
    organization: Pick<Organization, "logoUrl" | "name">;
    size?: AvatarSize;
    className?: string;
    /** Set when the organization's name is visible next to the logo. */
    "aria-hidden"?: boolean;
}

/**
 * A firm's logo as a square avatar. Firms without a logo show the square
 * Kick logo.
 */
export const OrganizationAvatar = ({
    organization,
    size,
    className,
    "aria-hidden": isAriaHidden,
}: Readonly<OrganizationAvatarProps>) => (
    <Avatar
        name={organization.name}
        src={organization.logoUrl}
        shape="square"
        fallback={<KickLogo variant="icon" />}
        size={size}
        className={className}
        aria-hidden={isAriaHidden}
    />
);
